import { keepPreviousData } from '@tanstack/react-query';
import { fetchRecipientsList } from '@/lib/api/email-flows';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import type { RecipientsListParams, RecipientsListResponse } from '../types';
import { useStanQuery } from '@/queries';

/**
 * Query hook for fetching recipients list
 */
export const useRecipients = (params: RecipientsListParams) => {
    return useStanQuery<RecipientsListResponse>(
        {
            queryKey: [QUERY_KEYS.RECIPIENTS_LIST, params],
            queryFn: () => fetchRecipientsList(params),
            staleTime: 5 * 60 * 1000, // 5 minutes
            placeholderData: keepPreviousData,
            meta: {
                error: {
                    sentryMessage: '[EMAIL_FLOWS] failed-to-fetch-recipients',
                    feature: SENTRY_FEATURES.EMAIL_FLOWS,
                },
            },
        },
        true
    );
};
